import { useEffect, useState } from "react";
import { fullElement, onFullChange } from "./fullscreen";

/**
 * Render by device (C16): phone-first layouts, desktop variants from 900px.
 * The layout holds while a player is full screen: a phone turned to landscape
 * can be 900px wide or more, and the other layout would build a new player
 * and drop the full screen. It catches up when the full screen ends.
 */
export function useIsDesktop(): boolean {
  const q = "(min-width: 900px)";
  const [is, setIs] = useState(() => (typeof window !== "undefined" ? window.matchMedia(q).matches : false));
  useEffect(() => {
    const m = window.matchMedia(q);
    const on = () => {
      if (!fullElement()) setIs(m.matches);
    };
    m.addEventListener("change", on);
    const off = onFullChange(on);
    return () => {
      m.removeEventListener("change", on);
      off();
    };
  }, []);
  return is;
}
